import { render, staticRenderFns } from "./ContractBaseInfo.vue?vue&type=template&id=393c5c78&scoped=true"
import script from "./ContractBaseInfo.vue?vue&type=script&lang=js"
export * from "./ContractBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./ContractBaseInfo.vue?vue&type=style&index=0&id=393c5c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c5c78",
  null
  
)

export default component.exports